import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {ResponseData} from "../../nest-responses";
import {
  ObjectData,
  RequestEmpShiftDto,
  RequestMatrixAttendanceDto,
  RequestShiftDailyList,
  ResponseEmpShiftDto,
  ResponseSaveDto,
  ResponseShiftDailyListDto
} from "../dto/shiftschedule.dto";

@Injectable()
export class ShiftscheduleApi {
  private readonly service: string = '';
  private readonly model: string = 'sf6s/shiftschedule';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public shiftDailyList(payload: RequestShiftDailyList): Observable<ResponseData<ResponseShiftDailyListDto>> {
    console.log('API RequestShiftDailyList', payload)
    const method: string = 'GET';
    const func: string = 'shiftDailyList';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseShiftDailyListDto>>(method, url, params, urlParams, body);
  }

  public matrixAttendance(payload: RequestMatrixAttendanceDto): Observable<ResponseData<ObjectData[][]>> {
    const method: string = 'GET';
    const func: string = 'matrixAttendance';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ObjectData[][]>>(method, url, params, urlParams, body);
  }

  public empShift(payload: RequestEmpShiftDto): Observable<ResponseData<ResponseEmpShiftDto>> {
    const method: string = 'GET';
    const func: string = 'empShift';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseEmpShiftDto>>(method, url, params, urlParams, body);
  }

  public save(payload: any): Observable<ResponseData<ResponseSaveDto>> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseSaveDto>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/shiftschedule.api.ts